import React, { Component } from 'react';
import { ToggleButton, ToggleButtonGroup, Row, Col, Image } from 'react-bootstrap';
import { SingleStemCalcDiameter, SingleStemCalcCircumference } from './singleStemCalc';
import { MSCalculatorDiameter, MSCalculatorCircumference } from './MSCalculator';
import TPZType1 from './TPZType1';
import TPZType2 from './TPZType2';
import Footnotes from './Footnotes';
import Glossary from './Glossary';
import Terms from './Terms';
import About from './About';

class TPZCalculator extends Component {
    constructor() {
        super();

        this.state = {
            incursionType: 1,
            stemType: 1,
            mesType: 1,
            srz: 1.5,
            tpzradius: 2,
            tpzarea: 12.6
        }

        this.incursionTypeSelection = this.incursionTypeSelection.bind(this)
        this.PZCalc = this.PZCalc.bind(this)
        this.handleStemCalcChange = this.handleStemCalcChange.bind(this)
    }

    incursionTypeSelection = () => {
        switch (this.state.incursionType) {
            case 1:
                return <TPZType1 tpzradius={this.state.tpzradius} tpzarea={this.state.tpzarea} srz={this.state.srz} />;
            case 2:
                return <TPZType2 tpzradius={this.state.tpzradius} tpzarea={this.state.tpzarea} srz={this.state.srz} />;
            default:
                return '';
        }
    }

    PZCalc = () => {
        switch (this.state.stemType) {
            case 1:
                return this.singleStemCalc();
            case 2:
                return this.multiStemCalc();
            default:
                return 'An error occured...';
        }
    }


    singleStemCalc = () => {

        switch (this.state.mesType) {
            case 1:
                return <SingleStemCalcDiameter pCallback={this.handleStemCalcChange} />;
            case 2:
                return <SingleStemCalcCircumference pCallback={this.handleStemCalcChange} />;
            default:
                return 'An error occured...'
        }
    }

    multiStemCalc = () => {

        switch (this.state.mesType) {
            case 1:
                return <MSCalculatorDiameter measurementType={this.state.mesType} pCallback={this.handleStemCalcChange} />;
            case 2:
                return <MSCalculatorCircumference measurementType={this.state.mesType} pCallback={this.handleStemCalcChange} />;
            default:
                return 'An error occured...'
        }


        //return <MSCalculator measurementType={this.state.mesType} pCallback={this.handleStemCalcChange} />;//<MSCalculator pCallback={this.handleStemCalcChange} />;
    }

    handleStemCalcChange = (e) => {

        if (typeof e.tpzradius != "undefined") {
            this.setState({
                tpzradius: e.tpzradius,

            })
        }

        if (typeof e.tpzarea != "undefined") {
            this.setState({
                tpzarea: e.tpzarea,

            })
        }

        if (typeof e.srz != "undefined") {
            this.setState({

                srz: e.srz
            })
        }
    }

    render() {
        return (
            <div>
                <a href="https://www.councilarboriculturevictoria.com.au/" target="blank">
                    <Image src="https://static1.squarespace.com/static/5df324d37e6e374ed0213297/t/5ed336b6e080e33f63a3422f/1590900408342/CAV_Logo_Text.png" width="315" />
                </a>
                <Row>
                    <Col>
                        <section className='bg-blue'>
                            <h4>AS 4970 Calculator</h4>
                            <p className="glossary-text">
                                The AS 4970 Calculator is a free web app based on the Australian Standard<sup>®</sup> AS 4970-2025 <i>Protection of trees on development sites</i>. The calculator allows you to calculate root zones (NRZ/SRZ) and the encroachment percentage for two types of encroachment. The calculator accepts circumference or diameter measurements and can calculate DSH for multi-stemmed trees.
                            </p>
                        </section>
                        <br />
                        <h5>Calculate Root Zones</h5>
                    </Col>
                    <Col sm={0} md={2} lg={2} />
                </Row>
                <Row className="justify-content-start">
                    <Col lg={3}><p>
                        <ToggleButtonGroup type="radio" name="stemType" defaultValue={1}>
                            <ToggleButton value={1} onClick={() => this.setState({ stemType: 1 })}>Single stem</ToggleButton>
                            <ToggleButton value={2} onClick={() => this.setState({ stemType: 2 })}>Multi stem</ToggleButton>
                        </ToggleButtonGroup></p>
                    </Col><Col>
                        <ToggleButtonGroup type="radio" name="mesType" defaultValue={1}>
                            <ToggleButton value={1} onClick={() => this.setState({ mesType: 1 })}>Diameter</ToggleButton>
                            <ToggleButton value={2} onClick={() => this.setState({ mesType: 2 })}>Circumference</ToggleButton>
                        </ToggleButtonGroup>
                    </Col>
                </Row>
                {this.PZCalc()}
                <Row>
                    <Col>
                        <hr style={{ backgroundColor: '#002A41', color: '#002A41' }} />
                        <br />
                    </Col>
                    <Col sm={0} md={2} lg={2} />
                </Row>

                <h5>Calculate Encroachment</h5>
                <ToggleButtonGroup type="radio" name="incType" defaultValue={1}>
                    <ToggleButton value={1} onClick={() => this.setState({ incursionType: 1 })}>Type A</ToggleButton>
                    <ToggleButton value={2} onClick={() => this.setState({ incursionType: 2 })}>Type B</ToggleButton>
                </ToggleButtonGroup>

                <p />
                {this.incursionTypeSelection()}
                <br />
                <Row>
                    <Col>
                        <Footnotes />
                    </Col>
                    <Col sm={0} md={2} lg={2} />
                </Row>
                <p />
                <br />
                <section className='bg-blue'>
                    <Glossary />
                </section>
                <p />
                <br />
                <Row>
                    <Col>
                        <About />
                    </Col>
                    <Col sm={0} md={2} lg={2} />
                </Row>
                <p />
                <Row>
                    <Col>
                        <Terms />
                    </Col>
                    <Col sm={0} md={2} lg={2} />
                </Row>
            </div>
        )
    }
}

export default TPZCalculator;